/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

(function ($, window, document) {
  'use strict';

  if (!$) {
    return;
  }

  var ARROW_LEFT = "<button type='button' class='slick-prev pull-left'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-left icon--direction-aware' viewBox='0 0 17 14'><path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>";
  var ARROW_RIGHT = "<button type='button' class='slick-next pull-right'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-right icon--direction-aware' viewBox='0 0 17 14'><path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>";

  function debounce(callback, wait) {
    var timeout;

    return function () {
      var context = this;
      var args = arguments;

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        callback.apply(context, args);
      }, wait);
    };
  }

  function rafThrottle(callback) {
    var ticking = false;

    return function () {
      var context = this;
      var args = arguments;

      if (ticking) {
        return;
      }

      ticking = true;

      window.requestAnimationFrame(function () {
        callback.apply(context, args);
        ticking = false;
      });
    };
  }

  function isSlickReady() {
    return typeof $.fn.slick === 'function';
  }

  function initSlick($element, options) {
    if (!$element.length || !isSlickReady() || $element.hasClass('slick-initialized')) {
      return;
    }

    $element.slick(options);
  }

  function refreshSlick($element) {
    if ($element.length && isSlickReady() && $element.hasClass('slick-initialized')) {
      $element.slick('refresh');
    }
  }

  function destroySlick($element) {
    if ($element.length && isSlickReady() && $element.hasClass('slick-initialized')) {
      $element.slick('unslick');
    }
  }

  function initMarqueeSlider() {
    initSlick($('.slick.marquee'), {
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
      draggable: false
    });
  }

  function initArticleSlider() {
    initSlick($('.article_list_section'), {
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: false,
      infinite: true,
      variableWidth: false,
      prevArrow: ARROW_LEFT,
      nextArrow: ARROW_RIGHT,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  function initCollectionSlider() {
    var $slider = $('.collections-list-slider');
    var slideCount = $('.collection-slide').length;

    if (!$slider.length || !isSlickReady()) {
      return;
    }

    if (window.innerWidth > 1200 && slideCount <= 6) {
      destroySlick($slider);
      return;
    }

    initSlick($slider, {
      slidesToShow: 6,
      slidesToScroll: 1,
      centerMode: false,
      infinite: true,
      variableWidth: false,
      prevArrow: ARROW_LEFT,
      nextArrow: ARROW_RIGHT,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    refreshSlick($slider);
  }

  function initProductSlider() {
    initSlick($('.Product-Slider-Section'), {
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      infinite: true,
      prevArrow: ARROW_LEFT,
      nextArrow: ARROW_RIGHT,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  function truncateText(selector, maxLength) {
    $(selector).each(function () {
      var $item = $(this);
      var text = $item.text().trim();

      if (text.length > maxLength) {
        $item.text(text.substring(0, maxLength - 2) + '..');
      }
    });
  }

  function initAccordions() {
    var $accordions = $('.Product_Accordion');

    if (!$accordions.length) {
      return;
    }

    $accordions.each(function () {
      var $accordion = $(this);
      var $items = $accordion.find('.Product_Accordion_Item');

      $accordion.addClass('Product_Accordion--initialized');
      $items.removeClass('activeToggle');
      $items.find('.accordion-title').removeClass('active');
      $items.find('.accordion-content').hide();

      $items.first().addClass('activeToggle');
      $items.first().find('.accordion-title').addClass('active');
      $items.first().find('.accordion-content').show();
    });

    $(document).off('click.productAccordion').on('click.productAccordion', '.Product_Accordion .accordion-title', function () {
      var $title = $(this);
      var $accordion = $title.closest('.Product_Accordion');
      var $items = $accordion.find('.Product_Accordion_Item');
      var $content = $title.next('.accordion-content');
      var $parent = $title.parent();

      if ($title.hasClass('active')) {
        return;
      }

      $items.find('.accordion-content').stop(true, true).slideUp();
      $items.find('.accordion-title').removeClass('active');
      $items.removeClass('activeToggle');

      $title.addClass('active');
      $content.stop(true, true).slideDown();
      $parent.addClass('activeToggle');
    });
  }

  function equalizeBlogExcerptHeights() {
    var $excerpts = $('.Blog_Listing .article-item .article-item__excerpt');
    var maxHeight = 0;

    if (!$excerpts.length) {
      return;
    }

    $excerpts.css('height', 'auto');

    $excerpts.each(function () {
      maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });

    $excerpts.css('height', maxHeight);
  }

  function updateArticleHeaderPadding() {
    var $headerContent = $('.article__header-content');
    var $container = $('.container').first();

    if (!$headerContent.length || !$container.length) {
      return;
    }

    if (window.innerWidth > 740) {
      $headerContent.css('padding-left', $container.offset().left + 60);
    } else {
      $headerContent.css('padding-left', '');
    }
  }

  function getStickyTop() {
    var announcementHeight = $('.shopify-section--announcement-bar').outerHeight() || 0;
    var headerHeight = $('.header').outerHeight() || 0;

    return announcementHeight + headerHeight + 1;
  }

  function initBlogStickyBar() {
    var $linkBar = $('.Blog_Template .link-bar');
    var stickyTop = getStickyTop();
    var isFixed = false;

    if (!$linkBar.length) {
      return;
    }

    $linkBar.css('top', stickyTop);

    var updateStickyTop = debounce(function () {
      stickyTop = getStickyTop();
      $linkBar.css('top', stickyTop);
    }, 150);

    var updateStickyState = rafThrottle(function () {
      var shouldBeFixed = window.pageYOffset >= 1;

      if (shouldBeFixed === isFixed) {
        return;
      }

      isFixed = shouldBeFixed;
      $linkBar.toggleClass('fixed', isFixed);
    });

    $(window).on('scroll', updateStickyState);
    $(window).on('resize orientationchange', updateStickyTop);

    updateStickyState();
  }

  function initCartRemoveButtons() {
    $('body').on('click', '.line-item__remove-button', function (event) {
      event.preventDefault();

      var variantId = $(this).closest('.line-item').attr('data-id');

      if (!variantId) {
        return;
      }

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          id: parseFloat(variantId),
          quantity: 0
        }
      }).then(function () {
        setTimeout(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }, 300);
      });
    });
  }

  function initSliders() {
    initMarqueeSlider();
    initArticleSlider();
    initCollectionSlider();
    initProductSlider();
  }

  function init() {
    initSliders();
    truncateText('.shopify-section--blog-posts .article-item__excerpt', 100);
    truncateText('.shopify-section--blog-posts .article-item__title', 60);
    initAccordions();
    initBlogStickyBar();
    initCartRemoveButtons();
    equalizeBlogExcerptHeights();
    updateArticleHeaderPadding();
  }

  var onResize = debounce(function () {
    initCollectionSlider();
    equalizeBlogExcerptHeights();
    updateArticleHeaderPadding();
  }, 150);

  $(document).ready(init);
  $(window).on('load', function () {
    refreshSlick($('.slick.marquee'));
    refreshSlick($('.article_list_section'));
    refreshSlick($('.collections-list-slider'));
    refreshSlick($('.Product-Slider-Section'));
    equalizeBlogExcerptHeights();
    updateArticleHeaderPadding();
  });
  $(window).on('resize orientationchange', onResize);
})(window.jQuery, window, document);


// $(document).ready(function() {

//   $('.slick.marquee').slick({
//     autoplay: true,
//     autoplaySpeed: 0,
//     speed: 5000,
//     cssEase: 'linear',
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     variableWidth: true,
//     infinite: true,
//     initialSlide: 1,
//     arrows: false,
//     buttons: false,
//     draggable: false
//   });
  
//   $('.article_list_section').slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     centerMode: false,
//     infinite: true,
//     variableWidth: false,
//     prevArrow:"<button type='button' class='slick-prev pull-left'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-left  icon--direction-aware ' viewBox='0 0 17 14'><path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
//     nextArrow:"<button type='button' class='slick-next pull-right'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-right  icon--direction-aware ' viewBox='0 0 17 14'><path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
//     responsive: [
//       {
//         breakpoint: 999,
//         settings: {
//           slidesToShow: 2
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1
//         }
//       }
//     ]
//   });
  
//   if($('.collection-slide').length > 6){
//   	$('.collections-list-slider').not('.slick-initialized').slick({
//       slidesToShow: 6,
//       slidesToScroll: 1,
//       centerMode: false,
//       infinite: true,
//       variableWidth: false,
//       prevArrow:"<button type='button' class='slick-prev pull-left'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-left  icon--direction-aware ' viewBox='0 0 17 14'><path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
//       nextArrow:"<button type='button' class='slick-next pull-right'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-right  icon--direction-aware ' viewBox='0 0 17 14'><path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
//       responsive: [
//         {
//           breakpoint: 1200,
//           settings: {
//             slidesToShow: 5
//           }
//         },
//         {
//           breakpoint: 999,
//           settings: {
//             slidesToShow: 2
//           }
//         },
//         {
//           breakpoint: 480,
//           settings: {
//             slidesToShow: 1
//           }
//         }
//       ]
//     });
//   }
        
//   $('.Product-Slider-Section').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     centerMode: false,
//     infinite: true,
//     prevArrow:"<button type='button' class='slick-prev pull-left slick-arrow'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-left  icon--direction-aware' viewBox='0 0 17 14'> <path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='2' fill='none'></path> </svg></button>",
//     nextArrow:"<button type='button' class='slick-next pull-right slick-arrow'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-right  icon--direction-aware' viewBox='0 0 17 14'> <path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='2' fill='none'></path> </svg></button>",
//     responsive: [
//       {
//         breakpoint: 1200,
//         settings: {
//           slidesToShow: 3
//         }
//       },
//       {
//         breakpoint: 999,
//         settings: {
//           slidesToShow: 2
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1
//         }
//       }
//     ]
//   });
  
  
//   jQuery(".shopify-section--blog-posts .article-item__excerpt").each(function(){
//     if(jQuery(this).text().length > 100){
//       jQuery(this).text(jQuery(this).text().substr(0,98)+'..');
//     }
//   });
  
//   jQuery(".shopify-section--blog-posts .article-item__title").each(function(){
//     if(jQuery(this).text().length > 60){
//       jQuery(this).text(jQuery(this).text().substr(0,58)+'..');
//     }
//   });

//   $(".accordion-content").hide(); 
//   $(".Product_Accordion_Item:first").addClass('activeToggle');
//   $(".Product_Accordion_Item:first .accordion-title").addClass('active');
//   $(".Product_Accordion_Item:first .accordion-content").show();
//   $(".accordion-title").click(function(){
//     $(this).toggleClass('active');
//     if($(this).hasClass('active')){
//       $('.accordion-content').slideUp();
//       $('.accordion-title').not(this).removeClass('active');
//       $('.accordion-block').removeClass('activeToggle');
//       $(this).addClass('active');
//       $(this).next('.accordion-content').slideDown();
//       $(this).parent().addClass("activeToggle"); 
//     } else {
//       $(this).removeClass('active');
//       $(this).next('.accordion-content').slideUp();
//       $(this).parent().removeClass("activeToggle"); 	
//     }
//   });
  
//   jQuery(".Blog_Listing .article-item .article-item__excerpt").each(function () {
//     function e() {
//       jQuery(".Blog_Listing .article-item .article-item__excerpt").css("height", "auto");
//       var e = -1;
//       jQuery(".Blog_Listing .article-item .article-item__excerpt").each(function () {
//         var t = jQuery(this).outerHeight();
//         e = t > e ? t : e
//       }), jQuery(".Blog_Listing .article-item .article-item__excerpt").css("height", e)
//     }
//     jQuery(this), jQuery(window).on("load resize orientationchange", e)
//   });

// });

// $(window).on("load resize orientationchange", function(event){
//   if (window.matchMedia('(max-width: 1200px)').matches){
//     if($('.collections-list-slider').hasClass('slick-initialized')){
//       $('.collections-list-slider').slick('refresh');
//     }
//     else{
//       $('.collections-list-slider').slick({
//         slidesToShow: 6,
//         slidesToScroll: 1,
//         centerMode: false,
//         infinite: true,
//         variableWidth: false,
//         prevArrow:"<button type='button' class='slick-prev pull-left'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-left  icon--direction-aware ' viewBox='0 0 17 14'><path d='M17 7H2M8 1L2 7l6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
//         nextArrow:"<button type='button' class='slick-next pull-right'><svg focusable='false' width='17' height='14' class='icon icon--nav-arrow-right  icon--direction-aware ' viewBox='0 0 17 14'><path d='M0 7h15M9 1l6 6-6 6' stroke='currentColor' stroke-width='2' fill='none'></path></svg></button>",
//         responsive: [
//           {
//             breakpoint: 9999,
//             settings: "unslick"
//           },
//           {
//             breakpoint: 1200,
//             settings: {
//               slidesToShow: 5
//             }
//           },
//           {
//             breakpoint: 999,
//             settings: {
//               slidesToShow: 2
//             }
//           },
//           {
//             breakpoint: 480,
//             settings: {
//               slidesToShow: 1
//             }
//           }
//         ]
//       });
//     }
//   }
// }); 

// jQuery(document).ready(function() {
//   jQuery(window).scroll(function(){
//     var sticky = jQuery('.Blog_Template .link-bar'),
//         scroll = jQuery(window).scrollTop();

//     if (scroll >= 1){
//       sticky.addClass('fixed');
//     }
//     else {
//       sticky.removeClass('fixed');
//     }

//     var announcement_height = $(".shopify-section--announcement-bar").height();
//     var header_height = $(".header").height();
//     var total_height = announcement_height + header_height
//     var final_height = total_height + 1
//     $(".Blog_Template .link-bar.fixed").css('top', final_height);
//   });
  
//   $('body').on('click','.line-item__remove-button', function(e){
//   	e.preventDefault();
//     var variantId = $(this).closest('.line-item').attr('data-id');
//         $.ajax({
//       type: "POST",
//       url: "/cart/change.js",
//       dataType: "json",
//       data: {
//         id: parseFloat(variantId),
//         quantity: 0,
//       },
//     }).then((data) => {
//           document.addEventListener('cart:updated', function(event) {
//             var cart = event.detail.cart; // Get the updated content of the cart
   
            
//           });
//           setTimeout(function(){
//             jQuery.getJSON('/cart.js', function(cart) {
//               document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//               bubbles: true
//             }));
//             });
//             },500);
//     });
//   });
// });


// $(window).on("resize", function () {
  
//   if ($(window).width() > 740) {
//     var leftspace = $(".container").offset().left;
//     var padding_left = leftspace + 60;
//     $('.article__header-content').css('padding-left',padding_left);
//   }

// }).resize();


